module.exports = {"en":"English","fr":"French"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en/locales.json
// module id = ez/4
// module chunks = 0